import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  'data-testid'?: string
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  'data-testid': testId,
}) => {
  const baseClasses = 'card'
  
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  }

  return (
    <div 
      className={`${baseClasses} ${className}`}
      data-testid={testId}
    >
      <div className={paddingClasses[padding]}>
        {children}
      </div>
    </div>
  )
} 